import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

export type ContratoCrearTipo = 'demo' | 'plan';

/**
 * Abre el modal Demo / Plan al pulsar «Crear contrato» y navega a `/contratos/crear?demo=`.
 * El modal se hospeda en `MainLayoutComponent` (no en la página de alta).
 */
@Injectable({ providedIn: 'root' })
export class ContratoCrearNavigationService {
  private readonly router = inject(Router);

  readonly modalVisible = signal(false);
  private pendingIdCuenta: number | null = null;

  /**
   * Muestra el modal de tipo. Tras Continuar navega con `demo=0|1`
   * y, si aplica, `id_cuenta`.
   */
  openCrear(options?: { idCuenta?: number | null }): void {
    const id = options?.idCuenta;
    this.pendingIdCuenta =
      id != null && Number.isFinite(id) && id > 0 ? Number(id) : null;
    this.modalVisible.set(true);
  }

  confirm(tipo: ContratoCrearTipo): void {
    this.modalVisible.set(false);
    const queryParams: Record<string, string | number> = {
      demo: tipo === 'demo' ? '1' : '0',
    };
    if (this.pendingIdCuenta != null) {
      queryParams['id_cuenta'] = this.pendingIdCuenta;
    }
    this.pendingIdCuenta = null;
    void this.router.navigate(['/contratos', 'crear'], { queryParams });
  }

  cancel(): void {
    this.modalVisible.set(false);
    this.pendingIdCuenta = null;
  }
}
